import type { AIOrHumanGame } from '@/types/aiOrHumanGame';

/**
 * Dados mock do jogo "IA ou Humano?"
 * Em produção, virão do backend via API
 */
export const mockAIOrHumanGame: AIOrHumanGame = {
  id: 'game-1',
  title: 'IA ou Humano?',
  baseXPPerRound: 10,
  passingScore: 60, // 60% de acerto mínimo
  rounds: [
    {
      id: 'round-1',
      roundNumber: 1,
      text: '"A inovação constante é o motor que impulsiona o crescimento sustentável nas organizações modernas, permitindo a adaptação rápida às mudanças de mercado."',
      hint: 'Observe a estrutura gramatical e a cadência das palavras.',
      correctAnswer: 'ai',
    },
    {
      id: 'round-2',
      roundNumber: 2,
      text: '"Cara, ontem eu tava pensando... sabe quando você fica meio perdido tipo assim, sem saber direito o que fazer? Então, aconteceu comigo na semana passada."',
      hint: 'Preste atenção nas pausas e expressões informais.',
      correctAnswer: 'human',
    },
    {
      id: 'round-3',
      roundNumber: 3,
      text: '"O machine learning representa um paradigma revolucionário na ciência da computação, possibilitando sistemas autônomos capazes de aprender padrões complexos através da análise de grandes volumes de dados."',
      hint: 'Analise o vocabulário técnico e a estrutura das frases.',
      correctAnswer: 'ai',
    },
    {
      id: 'round-4',
      roundNumber: 4,
      text: '"Eu sempre adorei café da manhã. Não sei explicar direito, mas tem algo no cheiro do pão quentinho que me lembra da casa da minha avó. Saudade daqueles domingos."',
      hint: 'Busque por conexões emocionais e memórias pessoais.',
      correctAnswer: 'human',
    },
    {
      id: 'round-5',
      roundNumber: 5,
      text: '"A implementação de estratégias de marketing digital requer uma abordagem integrada, combinando análise de dados, segmentação de público-alvo e criação de conteúdo relevante para maximizar o ROI."',
      hint: 'Note a presença de termos técnicos e estrutura formal.',
      correctAnswer: 'ai',
    },
    {
      id: 'round-6',
      roundNumber: 6,
      text: '"Sabe aquele momento em que você finalmente entende algo que tava te incomodando há tempos? Pois é, tive isso hoje e foi tipo uma luz se acendendo na minha cabeça. Muito doido."',
      hint: 'Observe as expressões coloquiais e a naturalidade da conversa.',
      correctAnswer: 'human',
    },
    {
      id: 'round-7',
      roundNumber: 7,
      text: '"Os benefícios da inteligência artificial na automação de processos empresariais incluem maior eficiência operacional, redução de custos e otimização da tomada de decisões estratégicas."',
      hint: 'Analise a objetividade e o tom corporativo.',
      correctAnswer: 'ai',
    },
    {
      id: 'round-8',
      roundNumber: 8,
      text: '"Meu irmão chegou em casa todo empolgado ontem, falando sobre um projeto novo no trabalho. Ele tava tão animado que esqueceu até de jantar, ficou só falando, falando, falando..."',
      hint: 'Procure por repetições e detalhes espontâneos.',
      correctAnswer: 'human',
    },
    {
      id: 'round-9',
      roundNumber: 9,
      text: '"A transformação digital nas empresas contemporâneas demanda investimentos em infraestrutura tecnológica, capacitação de colaboradores e redesenho de processos para garantir competitividade no mercado global."',
      hint: 'Verifique a densidade de informações e linguagem formal.',
      correctAnswer: 'ai',
    },
    {
      id: 'round-10',
      roundNumber: 10,
      text: '"Engraçado como a gente muda com o tempo, né? Coisas que eu achava super importante antes, hoje nem ligo tanto. E tem outras que eu nem dava bola que viraram prioridade. A vida é assim mesmo."',
      hint: 'Observe reflexões pessoais e tom filosófico informal.',
      correctAnswer: 'human',
    },
  ],
};
